import React, { Fragment, useContext } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AppContext } from "../context/AppContext";

import * as Md from "react-icons/md";
import { useNavigate } from "react-router-dom";

function Contents() {
  const navigate = useNavigate();
  const { contentsList, contentLoading } = useContext(AppContext);

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "");
  };

  return (
    <MasterLayout>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h6 className="my-3 mx-3">Content Management</h6>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <button
              type="button"
              className="add_btn_"
              style={{ width: "150px", top: "10px" }}
              onClick={() => navigate("/create-content")}
            >
              ADD
            </button>
          </div>
        </div>
        <div className="card p-4 w-100">
          <div class="content-display-container2">
            <div class="slug-section2">
              {contentsList &&
                contentsList.length != 0 &&
                contentsList.map((list, index) => {
                  return (
                    <>
                      <h2 class="slug-title2 text-capitalize" key={index}>
                        {list?.slug ?? "N/A"}
                      </h2>
                      <div class="content-items-container2">
                        <div className="row">
                          {list?.contents &&
                            list?.contents.length != 0 &&
                            list?.contents.map((item, idx2) => {
                              return (
                                <div
                                  className="col-lg-6 col-md-12 col-sm-12"
                                  key={idx2}
                                >
                                  <div class="content-item-card2">
                                    <div class="content-item-header2">
                                      <div class="content-item-info2">
                                        <span class="content-item-label2">
                                          Section:
                                        </span>
                                        <span class="content-item-value2">
                                          {item?.section_name}
                                        </span>
                                      </div>
                                      <button
                                        type="button"
                                        class="content-edit-button2"
                                        onClick={() =>
                                          navigate(
                                            `/update-content/${item?.id}?slug=${list?.slug}`
                                          )
                                        }
                                      >
                                        Edit
                                      </button>
                                    </div>

                                    <div class="content-item-details2">
                                      <div class="content-item-row2">
                                        <span class="content-item-label2">
                                          Key:
                                        </span>
                                        <span class="content-item-value2">
                                          {item?.content_key}
                                        </span>
                                      </div>
                                      <div class="content-item-row2">
                                        <span class="content-item-label2">
                                          Position:
                                        </span>
                                        <span class="content-item-value2">
                                          {item?.position}
                                        </span>
                                      </div>
                                      <div class="content-item-row2">
                                        <span class="content-item-label2">
                                          Content:
                                        </span>
                                        <div class="content-item-html2">
                                          <p>
                                            {" "}
                                            {stripHtmlTags(item?.content_value)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
}

export default Contents;
